import React, { useContext } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import LoginPage from "../../pages/Auth/Login";
//En lugar de pantalla de bienvenida, la pagina principal sin sesion es el formulario de acceso
//import WelcomePage from "../../pages/Auth/Welcome";
import WelcomePage from "../../pages/Auth/Login";
//Cambiamos la home (inicio) para que al loguearse siempre se vaya a la bandeja de entrada
//import HomePage from "../../pages/Home";
import HomePage from "../../pages/EntranceTable";
import NewUserPage from "../../pages/UserManagment/NewUser";
import ListUserPage from "../../pages/UserManagment/ListUser";
import EditUserPage from "../../pages/UserManagment/EditUser";
import EntranceTablePage from "../../pages/EntranceTable";
import ClaimHVPage from "../../pages/ClaimsHV";
import ArchivedPage from "../../pages/Archived";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import ForgotPassword from "../../pages/Auth/ForgotPassword";
import CreatePassword from "../../pages/Auth/CreatePassword";
import ClaimsHomePage from "../../pages/ClaimsForm/Home"
import ClaimFormPage from "../../pages/ClaimsForm/Claim"
import ClaimIVEFormPage from "../../pages/ClaimsForm/ClaimIVE"
import TrafficLightSystemTimesPage from "../../pages/Config/TrafficLightSystemTimes"
import DataOrganismsPage from "pages/Config/DataOrganisms";
import ProfilePage from "../../pages/UserManagment/Profile";
import UserManualPage from "../../pages/UserManual";
import ClaimViewPage from "pages/EntranceTable/Claim";
import ClaimIVEViewPage from "pages/ClaimsHV/ClaimIVE";
import StandardsProtocolsPage from "pages/StandardsProtocols"
import TicketsPage from "pages/Ticket/List"
import TicketsViewPage from "pages/Ticket/View"
import ReportsViewPage from "pages/Reports"
import { AppContext } from "../../context/AppContext";

function RouterContainer() {
    const { account } = useContext(AppContext);

    return (
        <Routes>
            <Route element={<PrivateRoute />}>
                <Route exact path="*" element={<Navigate to="/mesa-de-entrada" replace />} />
                <Route exact path="/inicio" element={<Navigate to="/mesa-de-entrada" replace />} />

                <Route
                    exact
                    path="/mesa-de-entrada"
                    element={<EntranceTablePage />}
                />
                <Route exact
                    path="/manual-de-uso"
                    element={<UserManualPage />}
                />
                <Route
                    exact
                    path="/perfil"
                    element={<ProfilePage />}
                />
                <Route
                    exact
                    path="/gestion-de-usuarios/crear-usuario"
                    element={<NewUserPage />}
                />
                <Route
                    exact
                    path="/gestion-de-usuarios/listado-de-usuarios"
                    element={<ListUserPage />}
                />
                <Route
                    exact
                    path="/gestion-de-usuarios/editar-usuario/:id"
                    element={<EditUserPage />}
                />
                <Route
                    exact
                    path="/mesa-de-entrada"
                    element={<EntranceTablePage />}
                />
                <Route
                    exact
                    path="/mesa-de-entrada/reclamo/:id"
                    element={<ClaimViewPage />}
                />
                <Route
                    exact
                    path="/reclamos-hv/reclamo-ive/:id"
                    element={<ClaimIVEViewPage />}
                />
                <Route
                    exact
                    path="/administrar/archivados"
                    element={<ArchivedPage />}
                />
                <Route
                    exact
                    path="/reclamos-hv"
                    element={<ClaimHVPage />}
                />
                <Route
                    exact
                    path="/configuracion/sistema-de-semaforos"
                    element={<TrafficLightSystemTimesPage />}
                />
                <Route
                    exact
                    path="/configuracion/datos-organismos"
                    element={<DataOrganismsPage />}
                />
                <Route
                    exact
                    path="/administrar/estandares-y-protocolos"
                    element={<StandardsProtocolsPage />}
                />
                <Route
                    exact
                    path="/tickets"
                    element={<TicketsPage />}
                />
                <Route
                    exact
                    path="/tickets/:id"
                    element={<TicketsViewPage />}
                />
                <Route
                    exact
                    path="/administrar/reportes/"
                    element={<ReportsViewPage />}
                />
            </Route>
            <Route element={<PublicRoute />}>
                <Route exact path="/" element={<WelcomePage />} />
                <Route exact path="/login" element={<LoginPage />} />
                <Route
                    exact
                    path="/forgot-password"
                    element={<ForgotPassword />}
                />
                <Route
                    exact
                    path="/create-password"
                    element={<CreatePassword />}
                />
                <Route
                    exact
                    path="/genera-tu-reclamo"
                    element={<ClaimsHomePage />}
                />
                <Route
                    exact
                    path="/genera-tu-reclamo/formulario-comun"
                    element={<ClaimFormPage />}
                />
                <Route
                    exact
                    path="/genera-tu-reclamo/formulario-ive"
                    element={<ClaimIVEFormPage />}
                />
            </Route>
        </Routes>
    );
}

export default RouterContainer;
